document.addEventListener('DOMContentLoaded', function() {
  // Referenz zum Head-Element und Dropdown
  const selectHead = document.querySelector('.select_font-item-head');
  const selectDropdown = document.querySelector('.font-picker__dropdown');
  
  // Öffnen/Schließen des Dropdowns beim Klicken auf den Header
  selectHead.addEventListener('click', function(e) {
    selectDropdown.classList.toggle('active');
    e.stopPropagation();
  });
  
  // Bei Klick außerhalb des Dropdowns wird es geschlossen
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.select_item-motivfont')) {
      selectDropdown.classList.remove('active');
    }
  });
  
  // Schriftart im Header aktualisieren, wenn eine Schriftart ausgewählt wird
  const fontInputs = document.querySelectorAll('.font-picker__input');
  const headLabel = selectHead.querySelector('.font-picker__label');
  
  fontInputs.forEach(input => {
    input.addEventListener('change', function() {
      if (this.checked) {
        const fontName = this.value;
        const fontLabel = this.nextElementSibling.textContent;
        const fontClass = this.nextElementSibling.className.split(' ')[1]; // Nimmt die zweite Klasse (font-spezifisch)
        
        // Alle Font-Klassen vom Header-Label entfernen
        const classes = headLabel.className.split(' ');
        classes.forEach(cls => {
          if (cls.startsWith('font-') && cls !== 'font-picker__label') {
            headLabel.classList.remove(cls);
          }
        });
        
        // Neue Font-Klasse hinzufügen
        headLabel.classList.add(fontClass);
        
        // Label aktualisieren
        headLabel.textContent = fontLabel;
        
        // Dropdown schließen nach Auswahl
        selectDropdown.classList.remove('active');
      }
    });
  });
  
  // Zusätzliche Event-Listener für die Label-Elemente hinzufügen
  const fontLabels = document.querySelectorAll('.font-picker__dropdown .font-picker__label');
  fontLabels.forEach(label => {
    label.addEventListener('click', function() {
      // Das zugehörige Input-Element auswählen und aktivieren
      const input = this.previousElementSibling;
      if (input && input.type === 'radio') {
        input.checked = true;
        
        // Change-Event auslösen
        const event = new Event('change');
        input.dispatchEvent(event);
      }
    });
  });
  
  // Initialisierung: Die ausgewählte Schriftart im Header anzeigen
  const checkedInput = document.querySelector('.font-picker__input:checked');
  if (checkedInput) {
    const fontName = checkedInput.value;
    const fontLabel = checkedInput.nextElementSibling.textContent;
    const fontClass = checkedInput.nextElementSibling.className.split(' ')[1];
    
    // Alle Font-Klassen vom Header-Label entfernen
    const classes = headLabel.className.split(' ');
    classes.forEach(cls => {
      if (cls.startsWith('font-') && cls !== 'font-picker__label') {
        headLabel.classList.remove(cls);
      }
    });
    
    // Font-Klasse hinzufügen und Label aktualisieren
    headLabel.classList.add(fontClass);
    headLabel.textContent = fontLabel;
  }
});